<button
    class="ap-button"
    [class]="'ap-button--' + variant()"
    [ngClass]="{
        'ap-button--text': text(),
        'ap-button--compact': compact(),
        'ap-button--wide': wide(),
        'ap-button--icon': iconName()
    }"
    [type]="type()"
    (click)="buttonClicked($event)"
    [attr.disabled]="isDisabled() ? isDisabled() : null"
    [attr.aria-label]="ariaLabel() ? ariaLabel() : null"
    [attr.aria-labelledby]="ariaLabelledBy() ? ariaLabelledBy() : null"
    [attr.aria-disabled]="isDisabled() ? isDisabled() : null"
    ngDefaultControl
>
    @if (iconName()) {
        <asn-icon [name]="iconName()" size="large" color="inherit" data-testid="icon"></asn-icon>
    }
    <ng-content></ng-content>
</button>
